export default __webpack_public_path__ + "static/media/logo-app-name_en.1d0f8784.svg";